export default __webpack_public_path__ + "static/media/heroImage-caseMobile.ea553541.jpg";